// removed by extract-text-webpack-plugin
module.exports = {"Toolbar":"Toolbar--11LZa"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Toolbar/Toolbar.scss
// module id = 957
// module chunks = 1